import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError, retry } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { MainService } from '../../../app.service';

@Injectable({ providedIn: 'root' })

export class JamesAdminService {

  constructor(private _http: HttpClient, private mainService: MainService) {
  }

  /*
  GET /jb/whitelist
  GET /jb/whitelist/:id
  POST /jb/whitelist
  PUT /jb/whitelist
  DELETE /jb/whitelist
  ah sim o put e o delete tem /:id no final
  GET /jb/config
  GET /jb/config/:id
  POST /jb/config
  PUT /jb/config/:id
  DELETE /jb/config/:id
  tem duas rotas de GET nos configs, mas é pro Protheus
  */

  // - JamesAdmin -------------------------------------------------------------------------------------------
  getRules(): Observable<any> {
    return this._http.get('/api/v2/jamesbond/config', this.mainService.httpOptions)
      .pipe(
        retry(3),
        map(rules => {
          return rules;
        }),
        catchError(this.mainService.handleError));
  }

  postRule(checkEnv,
    logError,
    checkUser,
    showInformer,
    alwaysShow,
    checkBuildVersion,
    maxOldVersion,
    informerKillUser,
    showWebMessage,
    webMessage,
    queryLog,
    release,
    isCanary,
    lastPTM,
    checkIni,
    isActive): Observable<any> {
    return this._http
      .post('/api/v2/jamesbond/config',
        JSON.stringify({
          checkEnv,
          logError,
          checkUser,
          showInformer,
          alwaysShow,
          checkBuildVersion,
          maxOldVersion,
          informerKillUser,
          showWebMessage,
          webMessage,
          queryLog,
          release,
          isCanary,
          lastPTM,
          checkIni,
          isActive
        }), this.mainService.httpOptions)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.mainService.handleError)
      );
  }

  editRule(id,
    checkEnv,
    logError,
    checkUser,
    showInformer,
    alwaysShow,
    checkBuildVersion,
    maxOldVersion,
    informerKillUser,
    showWebMessage,
    webMessage,
    queryLog,
    release,
    isCanary,
    lastPTM,
    checkIni,
    isActive): Observable<any> {
    return this._http
      .put(`/api/v2/jamesbond/config/${id}`,
        JSON.stringify({
          checkEnv,
          logError,
          checkUser,
          showInformer,
          alwaysShow,
          checkBuildVersion,
          maxOldVersion,
          informerKillUser,
          showWebMessage,
          webMessage,
          queryLog,
          release,
          isCanary,
          lastPTM,
          checkIni,
          isActive
        }), this.mainService.httpOptions)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.mainService.handleError)
      );
  }

  modifyRulesComponent(id, artefato, objeto): Observable<any> {
    this.mainService.updateHeaders();
    const request: any = {};
    request[artefato == "inikeys" ? "iniKeys" : artefato] = [objeto];

    return this._http.put(`/api/v2/jamesbond/config/${id}`, JSON.stringify(request), this.mainService.httpOptions)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.mainService.handleError)
      );
  }

}